import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input } from '@angular/core';
import { HiringService } from 'src/app/pages/hiring/services/hiring.service';
@Component({
  selector: 'app-delete-reset-onboard-task-modal',
  templateUrl: './delete-reset-onboard-task-modal.component.html',
  styleUrls: ['./delete-reset-onboard-task-modal.component.css'],
})
export class DeleteResetOnboardTaskModalComponent {
  @Input() pageData: any;
  @Input() task: any;
  @Input() mode: any;
  alert: any;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private hiringService: HiringService
  ) {}

  resetClicked() {
    this.hiringService.deleteTask(this.task.OnboardTaskID).then((response: any) => {
      this.activeModal.close(response.success);
    });
  }

  deleteClicked() {
    this.hiringService.deleteTask(this.task.OnboardTaskID).then((response: any) => {
      if (response.success) {
        this.activeModal.close((this.alert = { type: 'success', msg: 'Task has been deleted.' }));
      } else {
        this.activeModal.close((this.alert = { type: 'danger', msg: 'There were errors deleting the notification.' }));
      }
    });
  }

  closeClicked() {
    this.activeModal.dismiss();
  }
}
